import { ApiKeys } from '@app/constants/api-keys'
import { IInstitutionType } from '@app/interfaces/organization-passport/institution-type'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationPassportApi } from '.'
import { IRtkResponse } from '../../types'

export const institutionTypeApi = emptyOrganizationPassportApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getInstitutionTypes: build.query<
      IRtkResponse<IInstitutionType[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/institution-types',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IInstitutionType[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.institutionType,
                id,
              })),
              { type: ApiKeys.institutionType, id: 'LIST' },
            ]
          : [{ type: ApiKeys.institutionType, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.institutionType, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getInstitutionType: build.query<IInstitutionType, number>({
      query: (id) => ({
        url: `dictionary/api/v1/institution-types/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.institutionType, id },
      ],
    }),
  }),
})

export const { useGetInstitutionTypesQuery, useGetInstitutionTypeQuery } =
  institutionTypeApi
